import React, { type ComponentProps, useEffect, useRef } from 'react';
import { Platform, type View } from 'react-native';

import { IconLink } from '../../../../../Icon';

// ─────────────────────────────────────────────────────────────────────────────

export const ActiveIngredientQuantityStepperButton = (props: Props) => {
  const { autoFocusWeb, ...restProps } = props;

  // ─── Refs ────────────────────────────────────────────────────────────

  const ref = useRef<View>(null);

  // ─── Effects ─────────────────────────────────────────────────────────

  useEffect(() => {
    if (!autoFocusWeb || Platform.OS !== 'web') return;

    try {
      ref.current?.focus();
    } catch {}
  }, [autoFocusWeb]);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <IconLink
      ref={ref}
      iconSize={30}
      width={40}
      height={40}
      palette="oatmeal-almost-transparent"
      accessibilityRole="button"
      {...restProps}
    />
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  autoFocusWeb?: boolean;
} & ComponentProps<typeof IconLink>;
